<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import useWebsite from "@/composables/useWebsite";
import {computed} from "vue";

defineProps({
  inline: {
    type: Boolean,
    default: false,
  }
})

const { website } = useWebsite();

const url = computed(() => `/website/settings/${website.value?.id}#connected_accounts`);

</script>
<template>
  <div
    class="tw-flex tw-flex-col tw-items-center tw-space-y-2 tw-justify-center tw-my-8 tw-w-full tw-max-w-sm tw-mx-auto"
  >
    <div
      :class="[
        'tw-flex tw-gap-2 tw-items-center',
        inline ? '' : 'tw-flex-col'
      ]"
    >
      <svg-vue
        icon="icons/connect-ga"
        :class="[
          'tw-h-auto',
          inline ? 'tw-w-1/3 tw-mr-2' : 'tw-w-1/2'
        ]"
      />
      <p
        :class="[
          'tw-text-blue tw-semibold tw-leading-6',
          inline ? 'tw-text-left tw-text-lg' : 'tw-text-center tw-text-2xl',
        ]"
      >
        Compare your traffic stats!
      </p>
    </div>
    <p
      :class="[
        `tw-leading-5`,
        {
          'tw-text-center': !inline,
        }
      ]"
    >
      Connect your Google account to view your<br v-if="!inline"> data live.
      <a
        v-if="inline"
        :href="url"
        class="tw-text-blue tw-underline"
      >
        Connect your account now
      </a>
    </p>

    <DefaultButton
      v-if="!inline"
      :href="url"
      as="a"
    >
      Connect Your Account
    </DefaultButton>
  </div>
</template>